import {
	api_methods
} from '../../service/loadData'
import {cleanUserCache} from '@/service/cache'
import Vue from 'vue'
import axios from 'axios';
import {
	wechatUrl
} from '@/config/env'
import {
	SAVE_TOKEN,
	SAVE_USER,
	SAVE_USER_TIME,
	RECORD_USERINFO,
	SET_NAVMENUS,
	SAVE_TRACE,
	SET_SYS_CONFIG,

	SET_PROVINCES,
	SET_CITYS,
	SET_DISTRICTS,
	SET_TOWN,

	RECORD_GUESTINFO,
	SETPAGECONFIG,
	SETPAGECONFIGDETAIL,
	SETMAINTAIN,
	SETSERVICEURL,
	SAVEWAREHOUSE,
	SET_DEVICEID,
} from './mutation-types.js'
import {checkExpired} from '@/plugins/decorators'
import util from '@/config/util'
const Uppy = require('@uppy/core')
const Tus =	require('@uppy/tus')
import {endpoint,uploadRedirect} from '../../config/env'
let systemError = {msg:'系统异常，请稍后重试',code:-1};
const timeComparison = (str, str1,strnow) => {
    var valid_from = (!str) ? null : util.formatDate.dateFromStr(str);
	var valid_to = (!str1) ? null : util.formatDate.dateFromStr(str1);
	var now=util.formatDate.dateFromStr(strnow);
    return (valid_from <= now || !valid_from) &&
        (valid_to >= now || !valid_to)
}

export default {

	async getPageConfigAction({commit,state,getters},page){
		var newmodules=[];
		let uData = await api_methods.getPageConfig(getters.getAccessToken, getters.getUserId,null);
		if (uData?.response?.code == 1) {
			commit(SETPAGECONFIG,uData.data)
			newmodules=uData.data.value || []
		}
		else if(uData?.response?.code == 0){
			newmodules=uData.value || []
		}
		return newmodules.filter(u => u.Page == page && timeComparison(u.ValidFrom, u.ValidTo,getters.nowTime));
	},
	async getPageConfigDetailAction({commit,state,getters},{page,module}){
		var newmodules=[];
		let uData = await api_methods.getPageConfigDetail(getters.getAccessToken, getters.getUserId,null,module);
		if (uData?.response?.code == 1) {
			commit(SETPAGECONFIGDETAIL,uData.data)
			newmodules=uData.data.value || []
		}
		else if(uData?.response?.code == 0){
			newmodules=uData.value || []
		}
		return newmodules.filter(u => u.Page == page && timeComparison(u.ValidFrom, u.ValidTo,getters.nowTime));
	},
	async getBrandMenusAction({commit,state,getters}) {
		let uData = await api_methods.getBrandMenus(getters.getAccessToken, getters.getUserId);
		if (uData?.response?.code == 1) {
			return uData.data.value
		}
	},
	@checkExpired('sysConfig')
	async getSysConfigAction({commit,state,getters}) {
		let uData = await api_methods.sysConfig(getters.getAccessToken, getters.getUserId);
		if (uData && uData.data && (uData.response.code == '1'||uData.response.code == '-10')) {
			var errorCode=uData.response.errorCode
			if(errorCode=='1010'||errorCode=='1011'){
				api_methods.getMaintenance(getters.getAccessToken, getters.getUserId).then((sData)=>{
					if(sData?.response?.code == 1){
						commit(SETMAINTAIN,sData.data)
					}
				})
			}
			else{
				commit(SETMAINTAIN,null)
			}
			let uData2 = {}
			if (uData?.data?.value?.config?.bogo_switch[1] == '1') {
				uData2 = await api_methods.sysConfigCDN(getters.getAccessToken, getters.getUserId);
			}
			let data = Object.deepMerge(uData2,uData)
			commit(SET_SYS_CONFIG, data);
		} else if (uData.response.code == '-1') {
			commit(SET_SYS_CONFIG, null);
		}
	},
	async getArticleDetailAction({commit,state,getters},Code) {
		let uData = await api_methods.getArticleDetail(getters.getAccessToken, getters.getUserId,{Code});
		if (uData?.response?.code == 1) {
			return uData.data.value
		}
	},
	async getTipDetailAction({commit,state,getters},Code) {
		let uData = await api_methods.getTipDetail(getters.getAccessToken, getters.getUserId,{Code});
		if (uData?.response?.code == 1) {
			return uData.data.value
		}
	},
	async monitorTrace({getters,commit},code){
		commit(SAVE_TRACE,code);
	},
	@checkExpired('userInfo')
	async getCacheUserInfoAction({commit,getters},userToken) {
		commit(SAVE_TOKEN,userToken);
		let uData = await api_methods.getUserInfo(getters.getOpenId,userToken);
		if (uData && uData.data && uData.response.code == '1') {
			let value = uData.data.value.Value;  //接口调用结果
			if (value == 0){
				commit(SAVE_USER,null);
				commit(SAVE_TOKEN,null);
				commit('TRIGGER_MERGE','0');
				commit(RECORD_USERINFO, null);
				commit(SET_NAVMENUS,null);
				commit(SAVE_TRACE,{});
				commit('CLEAR_CART',null);
				commit('SET_COMBINEPROMOTEPRODUCT',null)
				commit(SETSERVICEURL,null)
				console.log('执行xxxxxxx')
				cleanUserCache()
				return {msg:'失败',code:-1};
			} 
			commit(SAVE_USER,uData.data);
			return null;
		}else {
			commit(SAVE_USER,null);
			commit(SETSERVICEURL,null)
			commit(SAVE_TOKEN,null);
			commit('TRIGGER_MERGE','0');
			commit(RECORD_USERINFO, null);
			commit(SET_NAVMENUS,null);
			cleanUserCache()
			return null;
		}
		return systemError;
	},
	async getUserInfoAction({commit,getters},userToken) {
		commit(SAVE_TOKEN,userToken);
		let uData = await api_methods.getUserInfo(getters.getOpenId,userToken);
		if (uData && uData.data && uData.response.code == '1') {
			let value = uData.data.value.Value;  //接口调用结果
			if (value == 0){
				commit(SAVE_USER,null);
				commit(SETSERVICEURL,null)
				commit(SAVE_TOKEN,null);
				commit('TRIGGER_MERGE','0');
				commit(RECORD_USERINFO, null);
				commit(SET_NAVMENUS,null);
				commit(SAVE_TRACE,{});
				commit('CLEAR_CART',null);
				commit('SET_COMBINEPROMOTEPRODUCT',null)
				console.log('执行xxxxxxx')
				commit('SET_ORPHANSHOWTIME',0)
				cleanUserCache()
				return {msg:'失败',code:-1};
			} 
			commit(SAVE_USER,uData.data);
			return null;
		}else {
			commit(SAVE_USER,null);
			commit(SAVE_TOKEN,null);
			commit('TRIGGER_MERGE','0');
			commit(RECORD_USERINFO, null);
			commit(SET_NAVMENUS,null);
			commit(SETSERVICEURL,null)
			commit('SET_ORPHANSHOWTIME',0)
			cleanUserCache()
			return null;
		}
		return systemError;
	},
	@checkExpired('wechatUserInfo')
	async getCacheWechatUserInfoAction({commit,state,getters}){
		var isOk=false
		let uData = await api_methods.getWechatUser(getters.getAccessToken,getters.getVipNo);
		if(uData && uData.data && uData.response.code == '1') {
			isOk=true;
			commit(RECORD_USERINFO, uData.data);
		} else if(uData.response.code == '-1') {
			commit(RECORD_USERINFO, null);
		}
		else if(uData.response.errorCode=='0001'){
			commit(RECORD_USERINFO, null);
		}

		if(!isOk){
			let oData = await api_methods.logOut(getters.getOpenId,getters.getAccessToken);
			if (oData && oData.data && oData.response.code == '1') {
				 commit(SAVE_USER,null);
				 commit(SAVE_TOKEN,null);
				 commit('TRIGGER_MERGE','0');
				 commit(RECORD_USERINFO, null);
				 commit(SET_NAVMENUS,null);
				 commit(SAVE_TRACE,{});
				 commit(SETSERVICEURL,null)
				 commit('SET_BIRTHDAYLIMT',-1)
				 
				 commit('CLEAR_CART',null);
				 commit('SET_COMBINEPROMOTEPRODUCT',null)
				 commit('SET_ORPHANSHOWTIME',0)
				 location.reload();
			}
		// 	Vue.prototype.$Modal.error({
		// 	   content:'用户信息错误,请重新登陆<br>Error userInfo, Please login in again',
		// 	   okText:'确认(confirm)',
		// 	   loading:true,
		// 		onOk:async ()=>{
				  
		// 	   }
		//    });
	   }

	},
	async getWechatUserInfoAction({commit,state,getters}) {
		var isOk=false
		let uData = await api_methods.getWechatUser(getters.getAccessToken,getters.getVipNo);
		if(uData && uData.data && uData.response.code == '1') {
			isOk=true;
			commit(RECORD_USERINFO, uData.data);
		} else if(uData.response.code == '-1') {
			commit(RECORD_USERINFO, null);
		}
		else if(uData.response.errorCode=='0001'){
			commit(RECORD_USERINFO, null);
		}

		

	},
	async saveStoreIdAction({commit,state,getters},data){
		let uInfo = state.wechatUserInfo;
		let user = (uInfo.value||{});
		let binding = (user.binding || {});
		let default_store_id=binding.default_store_id;
		let ddm = '0';
		let ddmd = '门店自提';
		let dsi = data.Code;
		let dsn = data.Name;
		let dse = data.NameEn;
		if(data.Code == '501') {//送货上门
			ddm = "1";
			ddmd = "送货上门";
		}
		var model={
			CustomerId:binding.user_id,
			DefaultDeliveryMode:ddmd,
			DefaultStoreId:dsi,
			DefaultStoreName:dsn,
			DefaultStoreNameEn:dse
		}
		var res=null;
		if(!state.saveWarehouse){
			res={data:{value:1}}
		}
		else{
			res=await api_methods.saveWarehouse(getters.getAccessToken, getters.getUserId,model)
		}	
		if(res&&res.data&&res.data.value&&res.data.value>0)
		{
			var uData={
				default_delivery_mode:ddm,
				default_delivery_mode_desc:ddmd,
				default_store_id:dsi,
				default_store_name:dsn,
				default_store_nameen:dse
			};
			
			binding.default_delivery_mode = uData.default_delivery_mode;
			binding.default_delivery_mode_desc = uData.default_delivery_mode_desc;
			binding.default_store_id = uData.default_store_id;
			binding.default_store_name = uData.default_store_name;
			binding.default_store_nameen=uData.default_store_nameen;

			commit(RECORD_USERINFO, uInfo);
			commit(SAVEWAREHOUSE,false);
			return null     
		}
		return '仓库保存失败,请重新尝试'
	},
	//选择发货仓库
	selectWarehouseAction({commit,state,getters},uData) {
		if(getters.getVipNo){
			var uInfo = state.wechatUserInfo;
			var user = (uInfo.value||{});
			var binding = (user.binding || {});

			binding.default_delivery_mode = uData.default_delivery_mode;
			binding.default_delivery_mode_desc = uData.default_delivery_mode_desc;
			binding.default_store_id = uData.default_store_id;
			binding.default_store_name = uData.default_store_name;
			binding.default_store_nameen=uData.default_store_nameen;
			
			commit(SAVEWAREHOUSE,true);
			commit(RECORD_USERINFO, uInfo);		
		}
		else{
			var guInfo = (state.guestInfo||{});
			var val = guInfo.value = (guInfo.value || {}); 			
			var binding = val.binding = (val.binding || {});
			// var user = (guInfo.value||{});
			// var binding = (user.binding || {});
			binding.default_delivery_mode = uData.default_delivery_mode;
			binding.default_delivery_mode_desc = uData.default_delivery_mode_desc;
			binding.default_store_id = uData.default_store_id;
			binding.default_store_name = uData.default_store_name;
			binding.default_store_nameen=uData.default_store_nameen;
			commit(RECORD_GUESTINFO, guInfo);	
		}
		

		
	},	
	async getFilesAction({getters},params){
		let uData = await api_methods.getFiles(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async getFileDetailAction({getters},params){
		let uData = await api_methods.getFileDetail(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async getMenuItemsAction({getters,commit}){
		let uData = await api_methods.getMenuItems(getters.getAccessToken,getters.getUserId);
		if (uData?.response?.code == 1) {
			commit(SET_NAVMENUS,uData.data)
			return uData.data.value;
		} else if(uData?.response?.code == 0){
			return uData.value;
		}
		return systemError;
	},
	async searchByKeysAction({getters},params){
		let uData = await api_methods.searchByKeys(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async getCommunityCatalogAction({getters},code){
		let uData = await api_methods.getCommunityCatalog(getters.getAccessToken,getters.getUserId,code);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async getCommunityArticleAction({getters},params){
		let uData = await api_methods.getCommunityArticle(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async getProvincesAction({
		commit,
		state,
		getters
	}) {

		let uData = await api_methods.getProvinces(getters.getAccessToken, getters.getUserId);
		if(uData && uData.data && uData.response.code == '1') {
			commit(SET_PROVINCES, uData.data);
		}
	},
	async getCitysAction({
		commit,
		state,
		getters
	}, parent_id) {
		let uData = await api_methods.getCitys(getters.getAccessToken, getters.getUserId);
		if(uData && uData.data && uData.response.code == '1') {
			commit(SET_CITYS, uData.data);
		}
	},
	async getDistrictsAction({
		commit,
		state,
		getters
	}, type) {
		let uData = await api_methods.getDistricts(getters.getAccessToken, getters.getUserId);
		if(uData && uData.data && uData.response.code == '1') {
			commit(SET_DISTRICTS, uData.data);
		} else if(uData.response.code == '-1') {
			commit(SET_DISTRICTS, null);
		}
	},
	async getTownAction({
		commit,
		state,
		getters
	}, parent_id) {
		let uData = await api_methods.getTown(getters.getAccessToken, getters.getUserId,parent_id);
		if(uData && uData.data && uData.response.code == '1') {
			console.log(uData.data)
			commit(SET_TOWN, uData.data);
			return uData.data.value
		}
		return [];
	},
	async getELearnCourseAction({getters,commit},params){
		let uData = await api_methods.getELearnCourse(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			let value = uData.data.value
			let courses = value.Courses,newCourses = [],uniqueTitles = []
			courses.forEach(item=>{
				let Section = {
					Lessons:item.Lessons,
					Title:item.Tag1,
					Code:item.Code,
					Id:item.Id,
				}
				let findIndex = uniqueTitles.indexOf(item.Title)
				if (findIndex == -1) {
					item.Sections = [Section]
					newCourses.push(item)
					uniqueTitles.push(item.Title)
				} else {
					newCourses[findIndex].Sections.push(Section)
				}
			})
			value.Courses = newCourses
			console.log(value)
			return value;
		}
		return systemError;
	},
	async getELearnExamAction({getters},params){
		let uData = await api_methods.getELearnExam(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async submitExamAction({getters},params){
		let uData = await api_methods.submitExam(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async getELearnCerAction({getters},params){
		let uData = await api_methods.getELearnCer(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async getExamResultAction({getters},rcode){
		let uData = await api_methods.getExamResult(getters.getAccessToken,getters.getUserId,rcode);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async getExamRecordAction({getters},lcode){
		let uData = await api_methods.getExamRecord(getters.getAccessToken,getters.getUserId,lcode);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	
	async getCommunityListAction({getters},params){
		let uData = await api_methods.getCommunityList(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async reportLessonProgressAction({getters},params){
		let uData = await api_methods.reportLessonProgress(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async reportFileDownloadAction({getters},params) {
		let uData = await api_methods.reportFileDownload(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async reportFileBrowseAction({getters},params) {
		let uData = await api_methods.reportFileBrowse(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
		return systemError;
	},
	async getServiceConfigAction({getters,commit,state}){
		// if (state.serviceUrl) return state.serviceUrl
		let uData = await api_methods.getServiceConfig(getters.getAccessToken,getters.getUserId);
		if (uData?.response?.code == 1) {
			// commit(SETSERVICEURL,uData.data.value)
			return uData.data.value;
		}
		return systemError;
	},
	async postFeedbackAction({getters},params){
		let uData = await api_methods.postFeedback(getters.getOpenId,getters.getVipNo,params);
		if (uData?.response?.code == 1) {
			return uData.data.value[0];
		}
		return systemError;
	},
	async loadFileAction({getters},file) {
		return new Promise(function (resolve,reject) {
			var URL = window.URL || window.webkitURL;
      		var thumb = URL.createObjectURL(file); 
      		var reader = new FileReader();  
               reader.onload = function(e){
               	let data = e.target.result;
				resolve({thumb,data});
               };
    		reader.readAsDataURL(file);
		});
	},
	async uploadImageAction({getters},{file,module}){   
		const handle = Uppy({
		  debug: true,
		  autoProceed: false,
		  meta:{
		  	system: "NewPCWeb",
			module:module || 'Default',
			emptyMetaKey:'', 
		  },
		  onBeforeFileAdded:(currentFile, files)=>{
		  	return currentFile
		  },
		  onBeforeUpload: (files) => {
			Object.keys(files).forEach(fileID => {
				handle.setFileMeta(fileID, { 
					contentType:files[fileID].type,
					oname:files[fileID].name,
					filetype:files[fileID].type,
					filename:files[fileID].name,
				}) 
			})
		  	return true
		  },
		  restrictions: {
		    // maxFileSize: 1000000,
		    maxNumberOfFiles: 1,
		    minNumberOfFiles: 1,
		    // allowedFileTypes: ['image/*']
		  }
		}).use(Tus, { 
			endpoint:endpoint,
		})
	    handle.addFile({
		  name: file.name, // file name
		  type: file.type, // file type
		  data: file, // file blob
		  meta: {
		    relativePath:"",
		  },
		  source: 'Local',
		  isRemote: false 
		})
		let result = await handle.upload()
		let successful = result.successful
		if (successful.length) {
			console.log(successful[0])
			let url = successful[0].uploadURL.replace(endpoint,uploadRedirect)
			let file = successful[0].data
			return {success:true,value:url,file}
			handle.reset()
		} else {
			return {success:false}
		}
	},
	async logOutAction({commit,getters},userToken) {
		let uData = await api_methods.logOut(getters.getOpenId,userToken);
		if (uData && uData.data && uData.response.code == '1') {
			let value = uData.data.value;  //接口调用结果
			commit(SAVE_USER,null);
			commit(SAVE_TOKEN,null);
			commit('TRIGGER_MERGE','0');
			commit(RECORD_USERINFO, null);
			commit(SET_NAVMENUS,null);
			commit(SAVE_TRACE,{});
			commit('CLEAR_CART',null);
			commit(SETSERVICEURL,null);
			commit('SET_BIRTHDAYLIMT',-1)
			commit('SET_COMBINEPROMOTEPRODUCT',null)
			commit('SET_ORPHANSHOWTIME',0)
			cleanUserCache()
			if (value == 0) return {msg:'失败',code:-1};
			return null;
		}
		return systemError;
	},
	async getDownloadMenusAction({commit,getters,state},code){
		let uData = await api_methods.getCommunityCatalog(getters.getAccessToken,getters.getUserId,code);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
	},
	async recordBrowsingAction({commit,getters,state},params) {
		if(getters.bogo_switch_5) return
			let openid = getters.getDeviceId
		if (!openid) {
			openid = util.guid()
			commit(SET_DEVICEID,openid)
		}
		params.openid = openid
		let uData = await api_methods.recordBrowsing(getters.getAccessToken,getters.getUserId,params);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
	},
	async getGuidesAction({getters},type){
		let uData = await api_methods.getGuides(getters.getAccessToken,getters.getUserId,type);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
	},
	async identifyAddressAction({getters},addressText){
		let uData = await api_methods.identifyAddress(getters.getAccessToken,getters.getUserId,addressText);
		return uData
	},
	async observeAction({getters},params) {
		let uData = await api_methods.observe(getters.getAccessToken,getters.getUserId,params);
		return uData
	},
	async getwxacodeAction({getters},scene) {
	    let envver = process.env.NODE_ENV == 'production' ? 'release':'trial'
	    let url = `${wechatUrl}/wx/miniapp?step=3&oldqr=unlimit&envver=${envver}&url=${encodeURIComponent(scene)}`
	    let res = await axios.get(url)
	    return res.data
	},
	async getOrphanModalCountAction({getters}) {
		let uData = await api_methods.getOrphanModalCount(getters.getAccessToken,getters.getUserId,getters.getVipNo);
		if (uData?.response?.code == 1) {
			return uData.data.value;
		}
	}
}